export const BASE_SM_CLASSES = "h-8 rounded-md text-sm"
export const BASE_MD_CLASSES = "h-11 rounded-lg"
export const BASE_DISABLED_CLASSES = "bg-gray-100 text-gray-400"
